export const GET_CAREER_SKILLS = 'GET_CAREER_SKILLS';
export const GET_CAREER_SKILL_BY_ID = 'GET_CAREER_SKILL_BY_ID';
export const UPDATE_CAREER_SKILL = 'UPDATE_CAREER_SKILL';
export const DELETE_CAREER_SKILL = 'DELETE_CAREER_SKILL';
export const CREATE_CAREER_SKILL = 'CREATE_CAREER_SKILL';
